(function(){
'use strict';

/* ---------- Dynamic product data (injected by build-your-ring.liquid) ---------- */
var DATA={moneyFormat:'${{amount}}',metalIndex:0,purityIndex:-1,initialVariantId:null,initialVariantPrice:0,initialMetalValue:'',initialPurityValue:'',goldFallback:{},variants:[],stones:[],defaultStoneKey:'',productKind:'ring',stoneAddonVariants:{}};
try{var dataEl=document.getElementById('byr-product-data');if(dataEl)DATA=Object.assign(DATA,JSON.parse(dataEl.textContent));}catch(e){console.error('BYR: could not parse product data',e);}

var STONE_MAP={};DATA.stones.forEach(function(s){STONE_MAP[s.key]=s;});
function stoneName(k){return STONE_MAP[k]?STONE_MAP[k].name:'Stone';}
function stonePerCarat(k){return STONE_MAP[k]?STONE_MAP[k].perCarat:0;}
function stoneDescriptor(k){return STONE_MAP[k]?STONE_MAP[k].descriptor:'';}

/* ---------- Money formatting (Shopify standard) ---------- */
function formatMoney(cents){
  if(typeof cents==='string')cents=cents.replace('.','');
  var value='';
  var placeholderRegex=/\{\{\s*(\w+)\s*\}\}/;
  var format=DATA.moneyFormat||'${{amount}}';
  function defaultOption(opt,def){return (typeof opt==='undefined'||opt===null)?def:opt;}
  function formatWithDelimiters(number,precision,thousands,decimal){
    precision=defaultOption(precision,2);thousands=defaultOption(thousands,',');decimal=defaultOption(decimal,'.');
    if(isNaN(number)||number===null)return 0;
    number=(number/100).toFixed(precision);
    var parts=number.split('.'),
        dollars=parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,'$1'+thousands),
        cents=parts[1]?decimal+parts[1]:'';
    return dollars+cents;
  }
  var match=format.match(placeholderRegex);
  switch(match?match[1]:'amount'){
    case 'amount':value=formatWithDelimiters(cents,2);break;
    case 'amount_no_decimals':value=formatWithDelimiters(cents,0);break;
    case 'amount_with_comma_separator':value=formatWithDelimiters(cents,2,'.',',');break;
    case 'amount_no_decimals_with_comma_separator':value=formatWithDelimiters(cents,0,'.',',');break;
    case 'amount_with_space_separator':value=formatWithDelimiters(cents,2,' ','.');break;
    case 'amount_no_decimals_with_space_separator':value=formatWithDelimiters(cents,0,' ','');break;
    case 'amount_with_apostrophe_separator':value=formatWithDelimiters(cents,2,"'");break;
    default:value=formatWithDelimiters(cents,2);
  }
  return format.replace(placeholderRegex,value);
}

/* ---------- State ---------- */
var state={
  currentStep:1,totalSteps:4,
  selectedSize:null,selectedEngraving:'',
  selectedStone:DATA.defaultStoneKey||'',
  selectedCarat:0.5,
  selectedShape:'Oval',
  selectedMetal:DATA.initialMetalValue||'14K Gold',
  selectedPurity:DATA.initialPurityValue||'Gold',
  selectedVariantId:DATA.initialVariantId,
  ringBaseCents:parseInt(DATA.initialVariantPrice,10)||0
};

var overlay=document.getElementById('byr-overlay'),modal=document.getElementById('byr-modal'),closeBtn=document.getElementById('byr-close'),nextBtn=document.getElementById('byr-next'),backBtn=document.getElementById('byr-back'),progressFill=document.getElementById('byr-progress-fill'),priceSummary=document.getElementById('byr-price-summary'),stoneDetails=document.getElementById('byr-stone-details');

/* ---------- Pricing helpers ---------- */
function stoneAddCents(){return Math.round(stonePerCarat(state.selectedStone)*state.selectedCarat);}
function totalCents(){return state.ringBaseCents+stoneAddCents();}

/* Find the Shopify variant matching the chosen metal value ("14K White Gold" etc.)
   by karat + colour tokens. Falls back to the first available variant so the
   cart always works regardless of how the product's options are structured. */
function normToken(s){return (s||'').toLowerCase().replace(/\s+/g,'');}
function findVariant(metalValue){
  var m=normToken(metalValue),
      karat=m.indexOf('18k')>-1?'18k':(m.indexOf('14k')>-1?'14k':''),
      isWhite=m.indexOf('white')>-1,
      firstAvail=null,firstAny=null,
      kAvail=null,kAny=null,
      kcAvail=null,kcAny=null;
  for(var i=0;i<DATA.variants.length;i++){
    var v=DATA.variants[i],
        t=normToken((v.title||'')+' '+((v.options||[]).join(' ')));
    if(!firstAny)firstAny=v;
    if(v.available&&!firstAvail)firstAvail=v;
    if(karat&&t.indexOf(karat)===-1)continue;
    if(!kAny)kAny=v;
    if(v.available&&!kAvail)kAvail=v;
    var colorOk=isWhite
      ? (t.indexOf('white')>-1)
      : (t.indexOf('white')===-1 && t.indexOf('rose')===-1 && (t.indexOf('gold')>-1 || t.indexOf('yellow')>-1));
    if(colorOk){
      if(!kcAny)kcAny=v;
      if(v.available&&!kcAvail)kcAvail=v;
    }
  }
  return kcAvail||kAvail||kcAny||kAny||firstAvail||firstAny;
}
function purityCents(label){
  var l=(label||'').toLowerCase().replace(/\s+/g,''),fb=DATA.goldFallback||{};
  if(l.indexOf('18k')>-1)return parseInt(fb['18k'],10)||0;
  if(l.indexOf('14k')>-1)return parseInt(fb['14k'],10)||0;
  return 0;
}
function applySelection(){
  var me=document.getElementById('byr-metal'),pe=document.getElementById('byr-purity');
  if(me&&me.options.length)state.selectedMetal=me.options[me.selectedIndex].text;
  if(pe&&pe.options.length)state.selectedPurity=pe.options[pe.selectedIndex].text;
  var variant=findVariant(state.selectedMetal);
  if(variant){
    state.selectedVariantId=variant.id;
    var form=document.getElementById('byr-cart-form');
    if(form){var idInput=form.querySelector('[name="id"]');if(idInput)idInput.value=variant.id;}
  }
  var cents=variant?(parseInt(variant.price,10)||0):0;
  if(!cents)cents=purityCents(state.selectedMetal);
  if(cents)state.ringBaseCents=cents;
  var rm=document.getElementById('review-metal');if(rm)rm.textContent=state.selectedMetal;
  var rpu=document.getElementById('review-purity');if(rpu)rpu.textContent=state.selectedPurity;
  var rp=document.getElementById('review-ring-price');if(rp)rp.textContent=formatMoney(state.ringBaseCents);
  updateSummary();
}

/* ---------- Modal ---------- */
function getHeaderHeight(){var sels=['#shopify-section-header .m-site-header','#shopify-section-header header','.m-site-header','header.m-site-header','.site-header','header[role="banner"]','.header-wrapper','#header','header'],el=null;for(var i=0;i<sels.length;i++){el=document.querySelector(sels[i]);if(el)break;}if(!el)return 70;var pos=window.getComputedStyle(el).position;if(pos==='fixed'||pos==='sticky')return el.offsetHeight;return Math.max(el.getBoundingClientRect().bottom,el.offsetHeight);}
function applyHeaderHeight(){document.documentElement.style.setProperty('--byr-header-h',getHeaderHeight()+'px');}

function openModal(){applyHeaderHeight();overlay.classList.add('is-open');modal.classList.add('is-open');overlay.setAttribute('aria-hidden','false');modal.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';goToStep(1);}
function closeModal(){overlay.classList.remove('is-open');modal.classList.remove('is-open');overlay.setAttribute('aria-hidden','true');modal.setAttribute('aria-hidden','true');document.body.style.overflow='';}

function goToStep(step){
  if(step>1&&!state.selectedSize){shakeSize();return;}
  state.currentStep=step;
  for(var i=1;i<=state.totalSteps;i++){var p=document.getElementById('byr-step-'+i);if(p){p.style.display=i===step?'flex':'none';if(i===step)p.style.flexDirection='column';}}
  updateProgress(step);
  backBtn.style.display=step>1?'inline-flex':'none';
  if(step===state.totalSteps){nextBtn.style.display='none';}else{nextBtn.style.display='inline-flex';nextBtn.textContent=step===3?'Review \u2192':'Next \u2192';}
  if(stoneDetails)stoneDetails.style.display=step===3?'block':'none';
  if(priceSummary)priceSummary.style.display=step===4?'block':'none';
  if(step===4)populateReview();
  var inner=modal.querySelector('.byr-modal__inner');if(inner)inner.scrollTop=0;
}
function shakeSize(){var g=document.getElementById('byr-size-grid');if(g){g.style.outline='2px solid var(--byr-gold)';g.style.borderRadius='2px';setTimeout(function(){g.style.outline='';g.style.borderRadius='';},1100);}var s=document.getElementById('byr-step-1');if(s){s.classList.add('byr-shake');setTimeout(function(){s.classList.remove('byr-shake');},500);}}
function updateProgress(cur){document.querySelectorAll('.byr-progress__step').forEach(function(el,idx){var n=idx+1;el.classList.remove('active','completed');if(n<cur)el.classList.add('completed');else if(n===cur)el.classList.add('active');});progressFill.style.width=((cur-1)/(state.totalSteps-1))*100+'%';}

/* ---------- Step 1: Size ---------- */
function initSizeGrid(){var g=document.getElementById('byr-size-grid');if(!g)return;g.addEventListener('click',function(e){var b=e.target.closest('.byr-size-btn');if(!b)return;g.querySelectorAll('.byr-size-btn').forEach(function(x){x.classList.remove('selected');x.setAttribute('aria-selected','false');});b.classList.add('selected');b.setAttribute('aria-selected','true');state.selectedSize=b.getAttribute('data-size');});}

/* ---------- Step 2: Engraving ---------- */
function initEngraving(){var inp=document.getElementById('byr-engraving-text'),prev=document.getElementById('byr-engraving-preview-text'),skip=document.getElementById('byr-skip-engraving');if(inp&&prev){inp.addEventListener('input',function(){var v=inp.value.trim();state.selectedEngraving=v;prev.textContent=v||'Your text will appear here';if(v)prev.classList.add('has-text');else prev.classList.remove('has-text');});}if(skip){skip.addEventListener('click',function(){state.selectedEngraving='';if(inp)inp.value='';if(prev){prev.textContent='Your text will appear here';prev.classList.remove('has-text');}goToStep(state.currentStep+1);});}}

/* ---------- Step 3: Carat + Stones ---------- */
function initCaratSlider(){var sl=document.getElementById('byr-carat-slider'),disp=document.getElementById('byr-carat-display'),bar=document.getElementById('byr-carat-bar');if(!sl)return;function upd(){var mn=parseFloat(sl.min),mx=parseFloat(sl.max),v=parseFloat(sl.value);state.selectedCarat=v;if(disp)disp.textContent=v+' ct';var pct=((v-mn)/(mx-mn))*100;if(bar)bar.style.width=pct+'%';updateStonePrices(v);}sl.addEventListener('input',upd);upd();}

function updateStonePrices(c){
  document.querySelectorAll('.byr-stone-card').forEach(function(card){
    var key=card.getAttribute('data-stone'),per=parseInt(card.getAttribute('data-per-carat'),10)||0,add=Math.round(per*c);
    var pe=card.querySelector('.byr-stone-card__price'),ce=card.querySelector('.byr-stone-card__carat');
    if(pe)pe.textContent=per===0?'Complimentary':'+ '+formatMoney(add);
    if(ce)ce.textContent=c+' carats';
  });
  updateSummary();
}

function initStoneGrid(){var g=document.getElementById('byr-stone-grid');if(!g)return;g.addEventListener('click',function(e){var c=e.target.closest('.byr-stone-card');if(!c)return;g.querySelectorAll('.byr-stone-card').forEach(function(x){x.classList.remove('active');x.setAttribute('aria-selected','false');});c.classList.add('active');c.setAttribute('aria-selected','true');state.selectedStone=c.getAttribute('data-stone');var choose=document.getElementById('byr-choose-stone');if(choose)choose.textContent='CHOOSE THIS '+stoneName(state.selectedStone).toUpperCase();updateSummary();});var chooseBtn=document.getElementById('byr-choose-stone');if(chooseBtn)chooseBtn.addEventListener('click',function(){goToStep(state.currentStep+1);});}

/* ---------- Diamond shape selector ---------- */
function injectShapeStyle(){var s=document.createElement('style');s.textContent='.byr-shape-section{margin-top:22px}.byr-shape-title{display:block;font-size:12px;letter-spacing:.12em;text-transform:uppercase;color:#c9a96e;margin-bottom:10px}.byr-shape-grid{display:grid;grid-template-columns:repeat(6,1fr);gap:8px}.byr-shape-card{display:flex;flex-direction:column;align-items:center;gap:6px;padding:10px 4px;background:transparent;border:1px solid rgba(201,169,110,.25);border-radius:2px;cursor:pointer;transition:border-color .2s,background .2s}.byr-shape-card:hover{border-color:rgba(201,169,110,.6)}.byr-shape-card.active{border-color:#c9a96e;background:rgba(201,169,110,.08)}.byr-shape-card__gem{width:34px;height:34px;display:block}.byr-shape-card__gem svg{width:100%;height:100%;display:block}.byr-shape-card__name{font-size:11px;color:#d8d8d8;letter-spacing:.04em}@media(max-width:640px){.byr-shape-grid{grid-template-columns:repeat(3,1fr)}}';document.head.appendChild(s);}
function initShapeGrid(){
  var g=document.getElementById('byr-shape-grid');if(!g)return;
  g.addEventListener('click',function(e){
    var c=e.target.closest('.byr-shape-card');if(!c)return;
    g.querySelectorAll('.byr-shape-card').forEach(function(x){x.classList.remove('active');x.setAttribute('aria-selected','false');});
    c.classList.add('active');c.setAttribute('aria-selected','true');
    state.selectedShape=c.getAttribute('data-shape');
    var rs=document.getElementById('review-shape');if(rs)rs.textContent=state.selectedShape;
    var sub=document.getElementById('review-stone-subtitle');if(sub)sub.textContent=buildStoneSubtitle();
  });
}

/* ---------- Selectors: Metal (variant-driven price) ---------- */
function initSelectors(){
  var me=document.getElementById('byr-metal'),pe=document.getElementById('byr-purity');
  if(me)me.addEventListener('change',applySelection);
  if(pe)pe.addEventListener('change',applySelection);
  if(me||pe)applySelection();
}

/* ---------- Step 4: Review + Summary ---------- */
function buildStoneSubtitle(){var d=stoneDescriptor(state.selectedStone),sh=state.selectedShape.toLowerCase(),nm=stoneName(state.selectedStone).toLowerCase();return (d?d+' ':'')+sh+' '+nm;}

function populateReview(){
  setText('review-shape',state.selectedShape);
  setText('review-metal',state.selectedMetal);
  setText('review-purity',state.selectedPurity);
  setText('review-size',state.selectedSize==='not-sure'?'Not Sure':(state.selectedSize||'\u2014'));
  setText('review-engraving',state.selectedEngraving||'None');
  setText('review-ring-price',formatMoney(state.ringBaseCents));
  setText('review-stone-name',stoneName(state.selectedStone).toUpperCase());
  setText('review-stone-subtitle',buildStoneSubtitle());
  setText('review-carat',state.selectedCarat);
  updateSummary();
}

function updateSummary(){
  var add=stoneAddCents(),total=totalCents();
  setText('summary-ring-price',formatMoney(state.ringBaseCents));
  setText('summary-stone-label',stoneName(state.selectedStone));
  setText('summary-stone-price',stonePerCarat(state.selectedStone)===0?'Complimentary':formatMoney(add));
  setText('summary-total',formatMoney(total));
  setText('summary-monthly',formatMoney(Math.round(total/12)));
}

function setText(id,v){var e=document.getElementById(id);if(e)e.textContent=(v!==null&&v!==undefined)?v:'\u2014';}

/* ---------- Stone Add-on cart-line guard ----------
   The Stone Add-on variant is priced at $0.01, and its quantity is set to the
   stone price in cents (e.g. $349.99 diamond -> qty 34999 x $0.01 = $349.99).
   This keeps the price mathematically exact, but left as-is the cart drawer
   shows a raw, unprofessional number (e.g. "34999") AND lets a shopper edit
   that quantity, which would change the stone's charged price.
   This guard finds that line item wherever/whenever the cart drawer renders
   (it re-renders via AJAX on every cart change) and:
     1. hides + disables its quantity input and +/- stepper buttons
     2. hides the raw large quantity number if the theme renders it as text
     3. adds a short, clear note so the price still reads as intentional
   NOTE: this is a front-end safeguard only. For airtight, server-enforced
   protection against a shopper editing the cart via direct API calls,
   Shopify Plus "Cart/Checkout Functions" (or an order-webhook price check)
   would be needed -- happy to help set that up if you're on Plus. */
function initStoneLineGuard(){
  var STONE_LABEL='Stone Add-on';

  function findCartRows(){
    return document.querySelectorAll(
      '.m-cart-drawer li, .m-cart-drawer [class*="cart-item"], '+
      '.cart-drawer li, .cart-drawer [class*="cart-item"], '+
      '[class*="cart-drawer"] [class*="cart-item"], '+
      '[class*="cart-drawer"] li'
    );
  }

  function guardRow(row){
    if(row.getAttribute('data-byr-guarded'))return;
    if(row.textContent.indexOf(STONE_LABEL)===-1)return;
    row.setAttribute('data-byr-guarded','true');
    row.classList.add('byr-stone-line');

    /* Hide + disable quantity inputs */
    row.querySelectorAll('input[type="number"], input[name*="quantity"], input[name*="updates"]').forEach(function(inp){
      inp.disabled=true;
      var wrap=inp.closest('[class*="qty"],[class*="quantity"]')||inp.parentElement;
      if(wrap)wrap.style.display='none';
      else inp.style.display='none';
    });

    /* Hide +/- stepper buttons */
    row.querySelectorAll('button, a').forEach(function(btn){
      var t=(btn.textContent||'').trim();
      var cls=(btn.className||'')+' '+(btn.getAttribute('aria-label')||'');
      if(t==='+'||t==='-'||t==='\u2212'||/quantity|qty[-_]?(plus|minus)/i.test(cls)){
        btn.style.display='none';
      }
    });

    /* Hide a raw large number left over from the quantity (e.g. "34999") */
    row.querySelectorAll('span,div,p').forEach(function(el){
      if(el.children.length)return;
      var t=(el.textContent||'').trim();
      if(/^\d{3,}$/.test(t))el.style.display='none';
    });

    /* Hide the raw $0.01 unit price if the theme prints it separately */
    row.querySelectorAll('span,div,p').forEach(function(el){
      if(el.children.length)return;
      var t=(el.textContent||'').trim();
      if(/^\$?0\.01$/.test(t))el.style.display='none';
    });

    /* Friendly note so the line still reads as intentional, not a glitch */
    if(!row.querySelector('.byr-stone-line-note')){
      var note=document.createElement('div');
      note.className='byr-stone-line-note';
      note.style.cssText='font-size:12px;opacity:.7;margin-top:4px;';
      note.textContent='Bundled with your custom ring — price included above.';
      var titleEl=row.querySelector('a,h3,h4,[class*="title"]')||row;
      titleEl.parentNode.insertBefore(note,titleEl.nextSibling);
    }
  }

  function apply(){findCartRows().forEach(guardRow);}
  apply();
  var obs=new MutationObserver(function(){apply();});
  obs.observe(document.body,{childList:true,subtree:true});
}

/* ---------- Add to bag ---------- */
/* --------- Add to bag (Cloudflare Worker Integration) --------- */
/* ---------- Add to bag (Cloudflare Worker Integration) ---------- */
function initAddToBag(){
  var btn=document.getElementById('byr-add-to-bag');if(!btn)return;

  btn.addEventListener('click',function(){
    if(btn.disabled)return;
    btn.disabled=true;

    var sp=btn.querySelector('span')||btn;
    var originalText=sp.textContent;
    sp.textContent='Building custom item...';

    // ✅ Aap ka exact Worker URL:
    var WORKER_URL = 'https://ring-builder-draft-order.bluxeellcdiamond.workers.dev/';

    var ringBase = state.ringBaseCents || 0;
    var stoneExtra = stoneAddCents() || 0;
    var finalTotalCents = totalCents();
    var stoneTitleName = stoneName(state.selectedStone);

    var customProductTitle = (state.selectedMetal || 'Custom Gold') + ' Ring with ' + (state.selectedShape || '') + ' ' + stoneTitleName;

    var propertiesPayload = {
      'Ring Size': state.selectedSize || 'Not Specified',
      'Engraving': state.selectedEngraving || 'None',
      'Stone Type': stoneTitleName,
      'Carat Weight': (state.selectedCarat || '') + ' ct',
      'Metal': state.selectedMetal || '',
      'Gold Purity': state.selectedPurity || '',
      'Shape': state.selectedShape || '',
      'Ring Base Price': formatMoney(ringBase),
      'Stone Price': stoneExtra > 0 ? formatMoney(stoneExtra) : 'Complimentary'
    };

    fetch(WORKER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        productTitle: customProductTitle,
        totalCents: finalTotalCents,
        properties: propertiesPayload
      })
    })
    .then(function(res){ 
      return res.text().then(function(text) {
        try {
          return JSON.parse(text);
        } catch(err) {
          throw new Error('Worker Response Error: ' + text);
        }
      });
    })
    .then(function(data){
      if(data.checkoutUrl){
        sp.textContent = 'Redirecting to Checkout...';
        window.location.href = data.checkoutUrl;
      } else {
        throw new Error(data.error || 'Checkout redirect failed.');
      }
    })
    .catch(function(err){
      console.error('BYR Checkout Error:', err);
      alert('Could not initiate checkout: ' + err.message);
      sp.textContent = originalText;
      btn.disabled = false;
    });
  });
}

function refreshCartCount(){fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){var n=cart.item_count||0;document.querySelectorAll('.m-cart-count,.cart-count,.cart-item-count,[data-cart-count],.js-cart-count,#cart-count,.count-bubble,.header__cart-count').forEach(function(el){el.textContent=n;if(n>0)el.style.display='';});['cart:refresh','cart:updated','theme:cart:update'].forEach(function(ev){try{document.dispatchEvent(new CustomEvent(ev,{bubbles:true}));}catch(e){}});}).catch(function(){});}

function openCartDrawer(){['cart:open','minimog:cart-open','cart-drawer:open','ajax-cart:open','theme:cart:open'].forEach(function(ev){try{document.dispatchEvent(new CustomEvent(ev,{bubbles:true}));}catch(e){}});setTimeout(function(){var open=document.querySelector('.m-cart-drawer.is-open,.cart-drawer.active,.cart-drawer.is-open');if(!open){var t=document.querySelector('[data-open-cart],[data-cart-toggle],#CartIcon,.m-cart-toggle');if(t)t.click();}},200);}

function initProgressClicks(){document.querySelectorAll('.byr-progress__step').forEach(function(el){el.addEventListener('click',function(){var t=parseInt(el.getAttribute('data-step'),10);if(t<state.currentStep)goToStep(t);});});}

function injectBYRButton(){
  if(document.querySelector('.byr-trigger-btn'))return;
  var sels=['.m-product-form--submit','button[name="add"]','[data-add-to-cart]','.m-btn-atc','form[action="/cart/add"] button[type="submit"]','.product-form__submit'],atc=null;
  for(var i=0;i<sels.length;i++){atc=document.querySelector(sels[i]);if(atc)break;}
  if(!atc){setTimeout(injectBYRButton,700);return;}
  var btn=document.createElement('button');
  btn.type='button';btn.id='byr-trigger';btn.className='byr-trigger-btn';
  btn.setAttribute('aria-label','Build Your Ring');
  btn.innerHTML='<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="4"/><line x1="12" y1="2" x2="12" y2="5"/><line x1="12" y1="19" x2="12" y2="22"/><line x1="2" y1="12" x2="5" y2="12"/><line x1="19" y1="12" x2="22" y2="12"/></svg><span>BUILD YOUR PRODUCT</span>';
  atc.parentNode.insertBefore(btn,atc);atc.style.display='none';
  btn.addEventListener('click',function(e){e.preventDefault();openModal();});
}

function bindEvents(){
  if(closeBtn)closeBtn.addEventListener('click',closeModal);
  if(overlay)overlay.addEventListener('click',closeModal);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&modal.classList.contains('is-open'))closeModal();});
  if(nextBtn)nextBtn.addEventListener('click',function(){goToStep(state.currentStep+1);});
  if(backBtn)backBtn.addEventListener('click',function(){goToStep(state.currentStep-1);});
  window.addEventListener('resize',function(){if(modal.classList.contains('is-open'))applyHeaderHeight();},{passive:true});
}

function injectShakeStyle(){var s=document.createElement('style');s.textContent='@keyframes byr-shake{0%,100%{transform:translateX(0)}25%{transform:translateX(-5px)}75%{transform:translateX(5px)}}.byr-shake{animation:byr-shake .45s ease}';document.head.appendChild(s);}

function init(){
  injectShakeStyle();injectShapeStyle();applyHeaderHeight();bindEvents();
  if(DATA.productKind==='earring'&&!state.selectedSize){state.selectedSize='Regular (Customer Choice)';}
  initSizeGrid();initShapeGrid();initEngraving();initCaratSlider();initStoneGrid();
  initSelectors();initAddToBag();initProgressClicks();initStoneLineGuard();
  updateStonePrices(state.selectedCarat);
  document.querySelectorAll('[data-byr-trigger]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();openModal();});});
  injectBYRButton();
}

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
else init();
})();